export default __webpack_public_path__ + "i18n/translations/translation-nl.cf4f460f.json";